export default __webpack_public_path__ + "img/day1.bb3ecd66.jpg";